import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const sections = {
    "Liens utiles": [
      {
        name: "Ministère de l'Agriculture et du Développement Rural",
        href: "https://www.agriculture.gouv.ci/",
      },
      {
        name: "Ministère des Ressources Animales et Alieutiques",
        href: "https://www.ressourcesanimales.gouv.ci/accueil/",
      },
      { name: "ANADER", href: "https://www.anader.ci/" },
    ],
    Légal: [
      { name: "Conditions d'utilisation", href: "#/" },
      { name: "Politique de confidentialité", href: "#/" },
      { name: "Politique relative aux cookies", href: "#/" },
    ],
  };

  return (
    <div className="bg-primary p-5">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 items-center sm:grid-cols-2">
        <div className="mx-auto max-w-2xl lg:mx-0 z-10">
          <h2 className="footer-title text-white text-3xl font-semibold ">
            Travailler avec nous
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-300 px-lg">
            Que vous soyez un passionné de l’agriculture durable, <br /> un
            amateur de produits fermiers frais ou simplement curieux <br /> de
            connaître les coulisses de notre métier. Vous y trouverez
            <br /> des récits sur nos méthodes de culture respectueuses de
            <br /> l’environnement.
            <div class=" w-full h-auto flex items-center  gap-4 flex-wrap">
              <button class="group rounded-full transition-all duration-500  hover:-translate-y-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 93 92"
                  fill="none"
                >
                  <rect
                    x="1.13867"
                    width="91.5618"
                    height="91.5618"
                    rx="15"
                    fill="#337FFF"
                  />
                  <path
                    d="M57.4233 48.6403L58.7279 40.3588H50.6917V34.9759C50.6917 32.7114 51.8137 30.4987 55.4013 30.4987H59.1063V23.4465C56.9486 23.1028 54.7685 22.9168 52.5834 22.8901C45.9692 22.8901 41.651 26.8626 41.651 34.0442V40.3588H34.3193V48.6403H41.651V68.671H50.6917V48.6403H57.4233Z"
                    fill="white"
                  />
                </svg>
              </button>

              <button class="group transition-all duration-500 hover:-translate-y-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 93 92"
                  fill="none"
                >
                  <rect
                    x="1.13867"
                    width="91.5618"
                    height="91.5618"
                    rx="15"
                    fill="#00D95F"
                  />
                  <path
                    d="M23.5068 66.8405L26.7915 54.6381C24.1425 49.8847 23.3009 44.3378 24.4211 39.0154C25.5413 33.693 28.5482 28.952 32.89 25.6624C37.2319 22.3729 42.6173 20.7554 48.0583 21.1068C53.4992 21.4582 58.6306 23.755 62.5108 27.5756C66.3911 31.3962 68.7599 36.4844 69.1826 41.9065C69.6053 47.3286 68.0535 52.7208 64.812 57.0938C61.5705 61.4668 56.8568 64.5271 51.5357 65.7133C46.2146 66.8994 40.6432 66.1318 35.8438 63.5513L23.5068 66.8405ZM36.4386 58.985L37.2016 59.4365C40.6779 61.4918 44.7382 62.3423 48.7498 61.8555C52.7613 61.3687 56.4987 59.5719 59.3796 56.7452C62.2605 53.9185 64.123 50.2206 64.6769 46.2279C65.2308 42.2351 64.445 38.1717 62.4419 34.6709C60.4388 31.1701 57.331 28.4285 53.6027 26.8734C49.8745 25.3184 45.7352 25.0372 41.8299 26.0736C37.9247 27.11 34.4729 29.4059 32.0124 32.6035C29.5519 35.801 28.2209 39.7206 28.2269 43.7514C28.2237 47.0937 29.1503 50.3712 30.9038 53.2192L31.3823 54.0061L29.546 60.8167L36.4386 58.985Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M54.9566 46.8847C54.5093 46.5249 53.9856 46.2716 53.4254 46.1442C52.8651 46.0168 52.2831 46.0186 51.7236 46.1495C50.8831 46.4977 50.3399 47.8134 49.7968 48.4713C49.6823 48.629 49.514 48.7396 49.3235 48.7823C49.133 48.8251 48.9335 48.797 48.7623 48.7034C45.6849 47.5012 43.1055 45.2965 41.4429 42.4475C41.3011 42.2697 41.2339 42.044 41.2557 41.8178C41.2774 41.5916 41.3862 41.3827 41.5593 41.235C42.165 40.6368 42.6098 39.8959 42.8524 39.0809C42.9063 38.1818 42.6998 37.2863 42.2576 36.5011C41.9157 35.4002 41.265 34.42 40.3825 33.6762C39.9273 33.472 39.4225 33.4036 38.9292 33.4791C38.4359 33.5546 37.975 33.7709 37.6021 34.1019C36.9548 34.6589 36.4411 35.3537 36.0987 36.135C35.7562 36.9163 35.5939 37.7643 35.6236 38.6165C35.6256 39.0951 35.6864 39.5716 35.8046 40.0354C36.1049 41.1497 36.5667 42.2144 37.1754 43.1956C37.6145 43.9473 38.0937 44.6749 38.6108 45.3755C40.2914 47.6767 42.4038 49.6305 44.831 51.1284C46.049 51.8897 47.3507 52.5086 48.7105 52.973C50.1231 53.6117 51.6827 53.8568 53.2237 53.6824C54.1018 53.5499 54.9337 53.2041 55.6462 52.6755C56.3588 52.1469 56.9302 51.4518 57.3102 50.6512C57.5334 50.1675 57.6012 49.6269 57.5042 49.1033C57.2714 48.0327 55.836 47.4007 54.9566 46.8847Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </p>
        </div>

        <div className="mx-auto mt-auto gap-8 max-w-2xl lg:mx-0 lg:max-w-none z-50">
          {Object.entries(sections).map(([sectionTitle, links]) => (
            <nav key={sectionTitle} className="my-8">
              <h6 className="footer-title text-white text-xl">
                {sectionTitle}
              </h6>
              <div className="flex flex-wrap gap-x-8 gap-y-6 text-base font-semibold leading-7 text-white lg:gap-x-10">
                {links.map((link) => (
                  <Link
                    target="_blank"
                    key={link.name}
                    to={link.href}
                    className="link link-hover underline-offset-1"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </nav>
          ))}
        </div>
      </div>
    </div>
  );
}
